export const ENV = {
  SITE_URL: process.env.GATSBY_SITE_URL,
};
